<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item">シリーズ</li>
            </ol>
        </nav>
        <div class="container">
            <div class="text-muted small p-2 my-2">
                小説のシリーズを管理できます。<br>
                「作品を束ねる」ことで、本棚の作品一覧には代表作品のみを掲載し、シリーズページへリンクすることができます。<br>
                短編集などを作成することができます。
            </div>
            <div class="d-flex justify-content-between">
                <div class="my-2">
                    <button type="button" class="btn btn-outline-success" @click="saveSort()" v-if="isSorted">
                        <i class="fas fa-sort-alpha-down"></i>
                        順番更新
                    </button>
                    <button type="button" class="btn btn-outline-secondary" @click="load()" v-if="isSorted">
                        <i class="fas fa-redo-alt"></i>
                        順番変更キャンセル
                    </button>
                </div>
                <div class="my-2">
                    <button type="button" class="btn btn-outline-primary" @click="showSeries()">
                        <i class="fas fa-plus"></i>
                        新規シリーズ追加
                    </button>
                </div>
            </div>
            <div class="card my-2" v-for="(v, i) in series" :key="v.id">
                <div class="card-body">
                    <div class="d-flex flex-wrap flex-lg-nowrap justify-content-between">
                        <div>
                            <h5 class="card-title">
                                <span class="handle mr-2" :class="{'font-weight-bold': sorted == v.id}">
                                    <router-link :to="`/mypage/series/${v.id}/books`" class="black">
                                        {{v.series_name}}
                                    </router-link>
                                </span>
                                <span class="badge badge-success badge-pill small" v-if="v.is_group">
                                    <i class="fas fa-layer-group"></i>
                                    作品を束ねる
                                </span>
                            </h5>
                            <p class="card-text small">{{v.description}}</p>
                        </div>
                        <div class="pt-4">
                            <router-link :to="`/mypage/series/${v.id}/books`" class="btn btn-link text-success">
                                <i class="fas fa-book"></i>
                                小説
                                {{v.books_count}} 冊
                            </router-link>
                            <button type="button" class="btn btn-link mr-2" @click="select(v.id)" v-if="series.length > 1">
                                <i class="fas fa-sort" v-if="!selected"></i>
                                <i class="fas fa-sort-up" v-else-if="i < selectedIndex"></i>
                                <i class="fas fa-sort-down" v-else-if="i > selectedIndex"></i>
                                <i class="fas fa-times" v-else></i>
                                <span v-if="!selected">移動</span>
                                <span v-else-if="i < selectedIndex">この上に移動</span>
                                <span v-else-if="i > selectedIndex">この下に移動</span>
                                <span v-else>移動をキャンセル</span>
                            </button>
                            <button type="button" class="btn btn-link mr-2" @click="showSeries(v.id)">
                                <i class="fas fa-edit"></i>
                                編集
                            </button>
                            <button type="button" class="btn btn-link text-danger" @click="remove(v.id)">
                                <i class="fas fa-times"></i>
                                削除
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="nothing" v-if="!series || !series.length">
                シリーズがありません。<br>
                新規にシリーズを追加してください。
            </div>
            <series-modal :series_id="series_id" @saved="load()"></series-modal>
        </div>
    </div>
</template>

<style scoped>
.handle {
    cursor: move;
}
</style>

<script>
import seriesModal from "./seriesModal";
export default {
    components: {
        seriesModal
    },
    data() {
        return {
            series: [],
            series_id: null,
            show: false,
            selected: null,
            sorted: null,
        }
    },
    methods: {
        load() {
            axios.get("/mypage/series/get").then(res => {
                this.series = res.data;
                this.show = true;
            }).catch(err => { alert.err(err.response) });
        },
        showSeries(id = null) {
            this.series_id = id;
            setTimeout(() => {$("#series-modal").modal()});
        },
        saveSort() {
            axios.post("/mypage/series/save-sort", {series: this.series}).then(res => {
                alert.msg(res.data);
                this.load();
            }).catch(err => { alert.err(err.response) });
        },
        remove(id) {
            Swal.fire({
                title: "シリーズ削除",
                html: `<div class="text-left">
                    指定のシリーズを削除します。<br>
                    シリーズを削除しても、小説は削除されません。<br>
                    削除しますか？
                    </div>`,
                icon: "error",
                showCancelButton: true,
                confirmButtonText: "削除",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/mypage/series/remove", {'id': id}).then(res => {
                        alert.msg(res.data);
                        this.load();
                    }).catch(err => {
                        alert.err(err.response);
                    });
                }
            });
        },
        select(id) {
            if (!this.selected) {
                // 選択
                this.selected = id;
                this.sorted = id;
            } else if (this.selected === id) {
                // 選択解除
                this.selected = null;
                this.sorted = null;
            } else {
                // 並び替え
                const from = this.selectedIndex;
                const dest = _.findIndex(this.series, {id: id});     // fromを抜く前のindex
                const src = this.series.splice(from, 1);
                const to = _.findIndex(this.series, {id: id});       // fromを抜いた後のindex
                if (from < dest) {
                    // 下がる
                    this.series.splice(to + 1, 0, src[0]);
                } else {
                    // 上がる
                    this.series.splice(to, 0, src[0]);
                }
                this.sorted = this.selected;
                this.selected = null;
            }
        }
    },
    computed: {
        isSorted() {
            for (let i = 0; i < this.series.length; i++) {
                if (this.series[i].order_number != (i + 1)) {
                    return true;
                }
            }
            return false;
        },
        selectedIndex() {
            return _.findIndex(this.series, {id: this.selected});
        },
    },
    mounted() {
        this.load();
    }
}
</script>